import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        cue: 0
    },
    mutations: {
        'SET_CUE' (state, val) { state.cue = val }
    },
    getters: {
        cue: state => state.cue,
    }
})
